import { format } from "date-fns";
import { Box, Button, Tooltip, Typography, Grid } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

export interface SmallerHeaderProps {
    personState?: {
        id: string | null,
        companyConsentPolicy: boolean
    }
    entityId: string,
    startDate: Date | null,
    consentStatus?: string | null,
    endDate?: Date | null,
    expired?: boolean | null,
    blockedExpireMessage?: string
    onExpire?: (id: string) => void
}

export default function SmallerHeader({ personState, entityId, startDate, endDate, expired = false, onExpire, blockedExpireMessage, consentStatus }: SmallerHeaderProps) {
    const onPersonManagePage = window.location.pathname.includes("user")
    const isItMe = entityId === personState?.id;
    const spaceAtCaps = (parentalConsentStatus: string | undefined | null) => {
        return parentalConsentStatus?.replace(/([A-Z])/g, " $1").trim();
    }
    return (
        <Grid container style={{ paddingTop: 16, paddingBottom: 16 }}>
            <Grid size={12}>
                <Box
                    component="div"
                    sx={{ display: "flex", justifyContent: "flex-end" }}
                >
                    <Grid container>
                        <Grid size={10}>
                            <Box component={"div"} style={{ display: "flex", justifyContent: "space-evenly" }}>
                                {(personState?.companyConsentPolicy && !onPersonManagePage) ?
                                    <Box component={"div"} style={{ marginRight: 32, }}>
                                        <Typography color="secondary" sx={{ fontSize: "14px" }}>
                                            Parental Consent
                                        </Typography>
                                        <Typography sx={{ fontSize: "18px" }}>
                                            {consentStatus ? spaceAtCaps(consentStatus) : "Not Requested"}
                                        </Typography>
                                    </Box> : <></>}

                                <Box component={"div"} style={{ marginRight: 32, }}>
                                    <Typography color="secondary" sx={{ fontSize: "14px" }}>
                                        Start Date
                                    </Typography>
                                    <Typography sx={{ fontSize: "18px" }}>
                                        {startDate
                                            ? format(new Date(startDate), "MM/dd/yyyy")
                                            : "n/a"}
                                    </Typography>
                                </Box>
                                <Box component={"div"} style={{ marginRight: 32, }}>
                                    <Typography color="secondary" sx={{ fontSize: "14px" }}>
                                        End Date
                                    </Typography>
                                    <Typography sx={{ fontSize: "18px" }}>
                                        {endDate
                                            ? format(new Date(endDate), "MM/dd/yyyy")
                                            : "n/a"}
                                    </Typography>
                                </Box>
                            </Box>
                        </Grid>
                        <Grid size={2} sx={{ display: "flex", justifyContent: "flex-end" }}>
                            <Tooltip title={blockedExpireMessage ? blockedExpireMessage : ""}>
                                <div>
                                    <Button disabled={blockedExpireMessage != undefined}
                                        sx={{ color: expired ? 'primary' : "#8E1C3B" }}
                                        onClick={() => onExpire && onExpire(entityId ?? '')}
                                        startIcon={
                                            expired
                                                ? (
                                                    <CheckCircleIcon />
                                                )
                                                : (

                                                    <CloseIcon
                                                        style={{
                                                            backgroundColor: "#8E1C3B",
                                                            borderRadius: "100%",
                                                            color: "white",
                                                        }}
                                                    />
                                                )
                                        }
                                    >
                                        {expired ? "Reactivate User" : "Expire User"}
                                    </Button>
                                </div>
                            </Tooltip>
                        </Grid>
                    </Grid>
                </Box>
            </Grid >
        </Grid >
    );
}